import { ReportType } from "@share/ticketSystem/enums/ReportType";
import { IdeaReports, ProblemReports, TicketReport } from "../types";

export type ReportsList<T> = Record<keyof T, TicketReport>

export const ideaReportsList: ReportsList<IdeaReports> = {
    reportIL1: {
        title: "Список идей",
        fullTitle: "Список всех поданных идей"
    },
    reportIL2: {
        title: "Отчет для линейных руководителей",
        fullTitle: "Список поданных идей с группировкой по подразделению и подробной информацией (дата, ФИО автора, подразделение, текст, статус, ответственный).",
    },
    reportIL3: {
        title: "Отклоненные идеи",
        fullTitle: "Список идей со статусом “Отклонено” с группировкой по подразделению и подробной информацией.",
    },
    reportIL4: {
        title: "Сроки реализации идей",
        fullTitle: "Список идей со статусами “Принять к реализации“ и “Реализовано“ с информацией о датах.",
    },
    reportIL5: {
        title: "Динамика подачи идей с описанием",
        fullTitle: "Список идей с фильтром по статусу “В реализации” с группировкой по подразделениям, и подробной информацией.",
    },
    reportIL6: {
        title: "Нерассмотренные идеи",
        fullTitle: "Список идей со статусом не “Отклонено”, группировкой по подразделениям и краткой информацией.",
    },
    reportIL7: {
        title: "Реализованные идеи",
        fullTitle: "Список реализованных идей с группировкой по подразделениям и краткой информацией"
    },
    reportIC1: {
        title: "Принятые идеи по участкам-отделам",
        fullTitle: "Распределение поданных идей по подразделениям без формирования списка.",
        reportType: ReportType.count
    },
    reportIC2: {
        title: "Принятые идеи за период",
        fullTitle: "Распределение поданных идей по подразделениям без формирования списка с фильтром по статусу идеи",
        reportType: ReportType.count
    },
    reportIC3: {
        title: "Поданные идеи (топ авторов)",
        fullTitle: "Распределение поданных идей по авторам с подсчетом общего количества",
        reportType: ReportType.count
    },
    reportIC4: {
        title: "Количество уникальных авторов и поданных идей по ним",
        fullTitle: "Распределение поданных идей по структурным единицам с подсчетом уникальных авторов и общего количества на каждом уровне.",
        reportType: ReportType.count
    },
    reportIG1: {
        title: "Поданные-принятые идеи",
        fullTitle: "Распределение поданных идей по организационной структуре с подсчетом уникальных авторов и общего количества на каждом уровне",
        reportType: ReportType.givenAndAccepted
    },
    reportIW1: {
        title: "Поданные идеи с разбивкой по категориям работников",
        fullTitle: "Распределение поданных идей по подразделениям и неделям с группировкой по категории автора и подсчетом общего количества",
        reportType: ReportType.weekly
    }
}

export const problemReportsList: ReportsList<ProblemReports> = {
    reportPL1: {
        title: "Список проблем",
        fullTitle: "Список всех поданных проблем"
    },
    reportPL2: {
        title: "Эскалация проблем",
        fullTitle: "Список поданных проблем с группировкой по подразделениям и подробной информацией."
    },
    reportPL3: {
        title: "Сроки устранения проблем",
        fullTitle: "Список поданных проблем с фильтром по дате устранения и статусами “Решено” и “В работе”."
    },
    reportPC1: {
        title: "Поданные проблемы (топ авторов)",
        fullTitle: "Распределение поданных проблем по авторам с подсчетом общего количества",
        reportType: ReportType.count
    },
    reportPC2: {
        title: "Отчет ДРП (проблемы по категориям)",
        fullTitle: "Распределение поданных проблем по категориям без формирования списка.",
        reportType: ReportType.count
    },
    reportPG1: {
        title: "Поданные-принятые проблемы",
        fullTitle: "Распределение поданных проблем по организационной структуре с подсчетом уникальных авторов и общего количества на каждом уровне",
        reportType: ReportType.givenAndAccepted
    },
    reportPW1: {
        title: "Поданные проблемы с разбивкой по категориям работников",
        fullTitle: "Распределение поданных проблем по подразделениям и неделям с группировкой по категории автора и подсчетом общего количества",
        reportType: ReportType.weekly
    }
}
